import { render, staticRenderFns } from "./material-category-form.vue?vue&type=template&id=5da5b0e3&"
import script from "./material-category-form.vue?vue&type=script&lang=js&"
export * from "./material-category-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports